<template>
  <div id="contenedor-municipios-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoMunicipio="registrarNuevoMunicipio"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado :listadoMunicipios="getMunicipios"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoMunicipio"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <registrar-nuevo-municipio
        v-if="mostrarVentanaRegistrarNuevoMunicipio"
        v-on:cerrar="cerrarRegistrarNuevoMunicipio">
      </registrar-nuevo-municipio>
    </v-dialog>
    <v-dialog
      v-if="esteMunicipio"
      v-model="mostrarVentanaEditarMunicipio"
      :width="!$vuetify.breakpoint.mobile ? '50%' : '90%'">
      <editar-municipio
        :municipioEditar="esteMunicipio"
        v-on:cerrar="cerrarEditarMunicipio">
      </editar-municipio>
    </v-dialog>
    <v-dialog
      v-if="esteMunicipio"
      v-model="mostrarVentanaEliminarMunicipio"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-municipio
        :municipioEliminar="esteMunicipio"
        v-on:cerrar="cerrarRemoverMunicipio">
      </eliminar-municipio>
    </v-dialog>
  </div>
</template>

<script>
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoMunicipio from '@/components/administracion/configuracion/catalogos/municipios/Nuevo.vue';
import EditarMunicipio from '@/components/administracion/configuracion/catalogos/municipios/Editar.vue';
import EliminarMunicipio from '@/components/administracion/configuracion/catalogos/municipios/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MunicipiosDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoMunicipio,
    EditarMunicipio,
    EliminarMunicipio,
    ToolBar,
    Listado,
  },
  apollo: {
    municipios: {
      query: MUNICIPIOS,
    },
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoMunicipio: false,
      mostrarVentanaEditarMunicipio: false,
      mostrarVentanaEliminarMunicipio: false,
      esteMunicipio: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  mounted() {
    eventBus.$on('editar-municipio', (municipio) => {
      this.esteMunicipio = municipio;
      this.mostrarVentanaEditarMunicipio = true;
    });
    eventBus.$on('eliminar-municipio', (municipio) => {
      this.esteMunicipio = municipio;
      this.mostrarVentanaEliminarMunicipio = true;
    });
  },
  methods: {
    registrarNuevoMunicipio() {
      this.mostrarVentanaRegistrarNuevoMunicipio = true;
    },
    cerrarRegistrarNuevoMunicipio() {
      this.mostrarVentanaRegistrarNuevoMunicipio = false;
    },
    cerrarEditarMunicipio() {
      this.mostrarVentanaEditarMunicipio = false;
      this.esteMunicipio = null;
    },
    cerrarRemoverMunicipio() {
      this.mostrarVentanaEliminarMunicipio = false;
      this.esteMunicipio = null;
    },
  },
  computed: {
    getMunicipios() {
      if (!this.municipios) return [];
      return this.municipios
      // Filtrar por Texto de Busqueda
        .filter((municipio) => {
          if (!this.filtros.buscarTexto) return municipio;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(municipio.nombre);
          const nombreCorto = this.$normalizacionTexto(municipio.nombreCorto);
          return (
            expt.test(nombre)
            || expt.test(nombreCorto)
            || expt.test(municipio.nombre)
            || expt.test(municipio.nombreCorto)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
